import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { CloudModel } from '../models/cloud-model';
import { ClientService } from './client.service';
import { StorageService } from './storage.service';
import { ZoneService } from './zone.service';
import { environment } from 'src/environments/environment';
import { storage as storageCatalog, event as eventCatalog } from 'src/app/utils/catalog';
import { ModelFactory } from '../models/model-factory';
import { ObjectService } from './object.service';
import { ZoneModel } from '../models/zone-model';
import { EventService } from './event.service';

@Injectable({
  providedIn: 'root',
})
export class CloudService {
  constructor(private client: ClientService, private objectService: ObjectService, private zoneService: ZoneService, private eventService: EventService) {}

  private async initCloud(id: string, values: any): Promise<CloudModel> {
    const cloud = ModelFactory.newInstance(CloudModel, {
      configuration: _.cloneDeep(_.get(environment.settings, id) || {}),
      ...values,
    });
    const cloudZoneGroups = cloud.configuration?.zoneGroups || [];

    const zonesById = _.keyBy(await this.zoneService.getZones(), 'id');

    for (const zoneGroup of cloudZoneGroups) {
      const zoneIds = zoneGroup.zones.map((zone) => (zone instanceof ZoneModel ? zone.id : zone));

      zoneGroup.zones = zoneIds.reduce((acc: Array<ZoneModel>, zoneId: string) => {
        if (zonesById[zoneId]) acc.push(zonesById[zoneId]);
        return acc;
      }, []);
    }

    return cloud;
  }

  async getCloud(): Promise<CloudModel> {
    const session = this.objectService.getActiveObject();

    return this.initCloud(session.cloudId, await this.client.get(`api/clouds/${session.cloudId}`));
  }

  async createOrUpdateCloud(patch: any): Promise<CloudModel> {
    const session = this.objectService.getActiveObject();
    const cloud = await this.initCloud(
      session.cloudId,
      await this.client.put(`api/clouds/${session.cloudId}`, {
        id: session.cloudId,
        ...patch,
      })
    );

    this.eventService.trigger(eventCatalog.types.cloudUpdate);

    return cloud;
  }
}
